import { render, staticRenderFns } from "./PackingList.vue?vue&type=template&id=02b89662"
import script from "./PackingList.vue?vue&type=script&lang=js"
export * from "./PackingList.vue?vue&type=script&lang=js"
import style0 from "./PackingList.vue?vue&type=style&index=0&id=02b89662&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports